import { Directive, ElementRef, inject } from '@angular/core';
import { fromEvent, shareReplay, tap } from 'rxjs';

export const SUBMITTED_CLASS = 'tvd-form-submitted';

@Directive({
  selector: 'form[formErrorHandler]',
})
export class FormErrorHandlerDirective {
  readonly #formEl: HTMLFormElement = inject(ElementRef<HTMLFormElement>)
    .nativeElement;

  readonly reset$ = fromEvent(this.#formEl, 'reset').pipe(
    shareReplay(1),
    tap(() => this.#formEl.classList.remove(SUBMITTED_CLASS)),
  );

  readonly submit$ = fromEvent(this.#formEl, 'submit').pipe(
    shareReplay(1),
    tap(() => this.#formEl.classList.add(SUBMITTED_CLASS)),
  );
}
